import { Component, OnInit } from '@angular/core';
import { AbstractFormComponent } from '../shared/common/abstract.component';
import { FormBuilder, Validators } from '@angular/forms';
import { FormGroup } from '@angular/forms';

import { QuestionControlService } from '@app/core/question-control.service';
import { QuestionService } from '@app/core/question.service';
import { QuestionBase } from '@app/core/models/question/question-base';
import { KycService } from '@app/core/kyc.service';
import { Kyc } from '@app/core/models/kyc';
import { AgentInfo } from '@app/core/models/agent';


@Component({
  selector: 'journey',
  templateUrl: './journey.component.html'
})
export class JourneyComponent extends AbstractFormComponent implements OnInit {
  kyc: Kyc;
  form: FormGroup;
  questions: QuestionBase<any>[];
  agent: AgentInfo;

  constructor(private _questionControlService: QuestionControlService,
    private _questionService: QuestionService) {
    super();
  }

  ngOnInit() {
    this.questions = this._questionService.getQuestions();
    this.form = this._questionControlService.toFormGroup(this._questionService.getQuestions());
  }
}



// WEBPACK FOOTER //
// ./src/app/features/journey.component.ts